import styled from '@emotion/styled';
import { ui } from '@libs/domain';
import { useItemNames } from '@ps-smart-cp/ppfw-client';
import { useNavigate } from 'react-router';
import type { SsoStatus } from '../../../types';
import type { LoginCredentials } from '../models';
import { FormSection } from './FormSection';
import { LoginLabelField } from './LoginLabelField';
import { StyledLoginButton } from './StyledLoginButton';
import { StyledLoginLink } from './StyledLoginLink';

const Separator = styled.div`
  margin-top: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  text-align: center;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #ccc;
  }

  &::before {
    margin-right: 10px;
  }

  &::after {
    margin-left: 10px;
  }
`;

interface LoginFormSsoRequiredProps {
  credentials: LoginCredentials;
  organizationName: string | undefined;
  ssoStatus: SsoStatus | undefined;
  onContinueWithSso: () => void;
}

export function LoginFormSsoRequired({
  credentials,
  organizationName,
  ssoStatus,
  onContinueWithSso,
}: LoginFormSsoRequiredProps) {
  const navigate = useNavigate();

  const labelNames = useItemNames(ui.labelNames);
  const buttonNames = useItemNames(ui.buttonNames);
  const linkNames = useItemNames(ui.linkNames);

  return (
    <>
      <FormSection>
        <LoginLabelField
          id="organization-id"
          head={`${labelNames('organizationId')}:`}
          body={credentials.organizationId}
        />
      </FormSection>
      <FormSection>
        <StyledLoginButton
          id="sso-btn"
          displayName={buttonNames('continueWithSso')}
          onClick={onContinueWithSso}
        />
      </FormSection>
      <FormSection>
        <StyledLoginButton
          id="cancel-btn"
          displayName={buttonNames('cancel')}
          onClick={() => navigate('/')}
        />
        <Separator>or</Separator>
      </FormSection>
      <FormSection>
        <StyledLoginLink
          id="sandbox-login"
          to="/sandbox-login"
          displayName={linkNames('sandboxLoginHere')}
          state={{ organizationId: credentials.organizationId, organizationName, ssoStatus }}
        />
      </FormSection>
    </>
  );
}
